import PalletsTransferHistory from 'components/PalletsTransferHistory/PalletsTransferHistory';
import WithAuth from 'hoc/withAuth';

const PalletsTransferHistoryPage = () => <PalletsTransferHistory mode="ROLE_DISTRIBUTION_CENTER" />;

export default WithAuth(PalletsTransferHistoryPage, 'ROLE_DISTRIBUTION_CENTER');
